export class KnownApiError extends Error {
  constructor(
    message: string,
    public responseStatus: number,
    public errorInfo: { message: string; code?: string; [key: string]: unknown },
    public responseObject: unknown
  ) {
    super(message);
    this.name = "KnownApiError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KnownApiError);
    }
  }
}

export class ApiUnavailableError extends Error {
  constructor(
    public responseStatus: number,
    public responseData: unknown
  ) {
    super("failed api request");
    this.name = "ApiUnavailableError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiUnavailableError);
    }
  }
}
